import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, RendererFactory2, VERSION } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ModuleRegistry, AllModules } from '@ag-grid-enterprise/all-modules';
import { AgGridModule } from '@ag-grid-community/angular';

import {
    UiRenderer, SideBarModule, PageModule, MainMenuModule,
    DatePickerModule, FooterModule, GridModule, ClipboardModule, InputsModule,
    ModalityModule
} from '@m27/common';
import { NgxMaskModule } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { environment } from '@app/environment';
import { IEnvironment } from '@shared/interfaces/index';
import { HomeComponent } from '@home/pages/home/home.component';
import { ResearchAuthModule } from '@core/authentication';
import { Http } from '@core/http/http';
import { HttpConfigInterceptor } from '@core/interceptors/http-config';
import { LoginComponent } from '@home/pages/login/login.component';
import { SafeHtmlPipe } from '@core/pipes/index';
import { AppInsightsService } from '@core/services/index';
import { PermitService } from '@shared/services/index';
import { AppDialogsComponent } from '@home/dialogs/dialog.component';
import { LoginDialogComponent } from '@home/dialogs/login/dialog-login.component';
import { MultiSelectDropdownModule } from '@shared/modules/multi-select-dropdown/multi-select-dropdown.module';
import { JiraDirective } from '@shared/directives/jira.directive';
import { StoryDirective } from '@shared/directives/story.directive';
import { BugDirective } from '@shared/directives/bug.directive';
import { MainMenuService } from '@shared/services/main-menu.service';
import { DropDownsService } from '@shared/services/drop-downs.service';

export function InitializeApp(ui: UiRenderer, renderFactory: RendererFactory2, http: Http): (ui, renderFactory, http, factory) => void {
    return () => {
        return new Promise((resolve, reject) => {
            ui.renderer = renderFactory.createRenderer(null, null);

            const loc = window.location;
            let eJson = 'unknown';

            switch (loc.host.toLowerCase()) {
                case 'localhost:4455':
                    eJson = 'local';
                    break;
                case 'gatekeeper-dev.se.research.vylor.com':
                    eJson = 'dev';
                    break;
                case 'gatekeeper-test.se.research.vylor.com':
                    eJson = 'train';
                    break;
                case 'gatekeeper.se.research.vylor.com':
                    eJson = 'production';
                    break;
            }

            http.get(`assets/environment.${eJson}.json`).subscribe((response: IEnvironment) => {
                for (const property in response) {
                    if (Object.prototype.hasOwnProperty.call(response, property)) {
                    // if (response.hasOwnProperty(property)) {
                        environment[property] = response[property];
                    }
                }

                resolve();
            });
        });
    };
}

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        LoginComponent,
        SafeHtmlPipe,
        AppDialogsComponent,
        LoginDialogComponent,
        JiraDirective,
        BugDirective,
        StoryDirective
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,

        /*  */

        MultiSelectDropdownModule,

        /* part of m27-common */
        SideBarModule,
        PageModule,
        MainMenuModule,
        FooterModule,
        DatePickerModule,
        GridModule,
        ClipboardModule,
        InputsModule,
        ModalityModule,


        /* peer of m27-common */
        NgxMaskModule,
        AgGridModule.withComponents([]),

        ResearchAuthModule.withInterceptors([...ResearchAuthModule.defaultInterceptors(), {
            provide: HTTP_INTERCEPTORS,
            useFactory: AppModule.loadingInterceptorFactory,
            deps: [],
            multi: true
        }])
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: InitializeApp,
            deps: [UiRenderer, RendererFactory2, Http],
            multi: true
        },
        Http,
        UiRenderer,
        PermitService,
        AppInsightsService,
        MainMenuService,
        DropDownsService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor() {    
        ModuleRegistry.registerModules(AllModules);

        const g = 'color:#0F52BA;font-weight:bold;font-size:24px; font-family:Arial;letter-spacing:-1.5em;';
        const b = 'color:#007ACC;font-weight:bold;font-size:24px; font-family:Arial;';
        const cb = 'color:#777;font-weight:bold;font-size:13px; font-family:Arial;letter-spacing:0.02em;';
        const jd = 'color:#007ACC;font-weight:bold;font-size:15px; font-family:Arial;';

        console.log('%cGate%ckeeper  %c Created by %cAgronauts', g, b, cb, jd);
        console.log(`App initialized - Angular v${VERSION.full}`);
    }

    public static loadingInterceptorFactory() {
        return new HttpConfigInterceptor();
    }
}
